import { render, staticRenderFns } from "./BlankSection.vue?vue&type=template&id=30e33d22&"
import script from "./BlankSection.vue?vue&type=script&lang=js&"
export * from "./BlankSection.vue?vue&type=script&lang=js&"
import style0 from "./BlankSection.vue?vue&type=style&index=0&id=30e33d22&prod&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.10.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports